import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComProductCollectAmountModel } from 'src/app/model/com-product-collect-amount.model';
import { DependencyAffiliateModel, HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductCollectAmountService } from 'src/oldApp/services/com-product-collect-amount.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';

@Component({
  selector: 'app-modal-sc-product-collect-amount',
  templateUrl: './modal-sc-product-collect-amount.component.html',
  styleUrls: ['./modal-sc-product-collect-amount.component.css']
})
export class ModalScProductCollectAmountComponent implements OnInit {
  @Input() commission:ComProductCollectAmountModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public businessLineCatalog:HMGenericCatalog[]=[];
  public productCOECatalog:HMGenericCatalog[]=[];
  public dealerCatalog:CatalogModel[]=[];
  public paymentTypeCatalog:CatalogModel[]=[];
  public employeeJobCatalog:CatalogModel[]=[];
  public collectAmountGroupCatalog:any=[
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'}
  ];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  /////////////////
  constructor(
    private itemsService:ComProductCollectAmountService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private employeeJobService:CatEmployeeJobService,
    private modalService: NgbModal,
    private utils:UtilitiesService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    console.log(this.commission)
    this.getCatalogs();
  }

  //
  updateBusinessLine=()=> {}
  updateProductCOE=()=> {}
  updateDealer=()=> {}
  updatePaymentType=()=> {}
  updateEmployeeJob=()=> {}
  updateCollectAmountGroup=()=> {}
  toggleActive=()=> this.commission.activeId=!this.commission.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.businessLineError()) errors.push('Necesita seleccionar una línea de negocio.');
    if(this.productCOEError()) errors.push('Necesita seleccionar un producto.');
    if(this.dealerError()) errors.push('Necesita seleccionar un convenio.');
    if(this.paymentTypeError()) errors.push('Necesita seleccionar un plazo.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.collectAmountGroupError()) errors.push('Necesita seleccionar un grupo.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.itemsService.save(this.commission)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  businessLineError=()=> !this.commission.businessProductId;
  productCOEError=()=> !this.commission.productosCOEId;
  dealerError=()=>  !this.commission.dealerId;
  paymentTypeError=()=> !this.commission.paymentId;
  employeeJobError=()=> !this.commission.employeeJobId;
  collectAmountGroupError=()=> !this.commission.collectAmountGroupId;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.hypermatrixCatalogsService.getCatalog('BusinessProductType'),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
      this.vwCommissionConfiguratorService.getAfiliates(),
      this.vwCommissionConfiguratorService.getPayments(),
      this.employeeJobService.catalog()
    )
    .pipe(
      tap(([bpResp, prodResp, dealerResp, paymentResp, empJobResp]:[any, any, any, any, any])=> {
        if(bpResp && prodResp && dealerResp && empJobResp) {
          this.businessLineCatalog=bpResp.data.filter(t=> t.idCatalogType!=3 );
          this.productCOECatalog=prodResp.data.sort(this.utils.sortBy('description'));
          this.dealerCatalog=dealerResp.data.sort(this.utils.sortBy('description'));
          let plaz:number[]=[1,2,4,7,10,12];
          this.paymentTypeCatalog=paymentResp.data.filter(t=> plaz.includes(t.id)).sort(this.utils.sortBy('description'));
          this.employeeJobCatalog=empJobResp.data.filter(i=> i.id==4);
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}
